export default "__VITE_ASSET__1cd39fdf__"